import { StopCodingProvider } from "../components/OI/redux/ReduxContext";
import StopCodingDashboardNew from "./StopCodingDashboardNew";

export default function StopCodingView() {
    return (
        <StopCodingProvider>
            <StopCodingDashboardNew />
        </StopCodingProvider>
    );
}